<script setup lang="ts">
import { computed } from 'vue';
import { UiText, UiAvatar, generateInitials } from '@shopexperts/shared';

export interface ExpertData {
    name: string;
    type: 'freelancer' | 'agency';
    slug: string;
    profile_picture?: string | null;
    role?: string | null;
}

const props = defineProps<{
    expert: ExpertData;
}>();

const expertTypeLabel = computed(() => {
    return props.expert.type === 'freelancer' ? 'Freelancer' : 'Agency';
});
</script>

<template>
    <div class="bg-white border border-se-gray-300 rounded-lg p-4 w-full">
        <div class="flex gap-3 items-center w-full">
            <UiAvatar 
                :url="expert.profile_picture ?? undefined" 
                :initials="generateInitials(props.expert.name)" 
                size="sm" 
            />
            <div class="flex flex-col items-start shrink">
                <UiText as="span" class="font-semibold" :text="expert.name" />
                <UiText v-if="expert.role" as="span" variant="h6" class="text-se-gray-700" :text="expert.role" />
                <UiText as="span" variant="h6" class="text-se-gray-700" :text="expertTypeLabel" />
            </div>
        </div>
    </div>
</template>
